import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "App-Startup-Users-List" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_appStartupUser = _resolveComponent("appStartupUser")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_space, {
      fill: "",
      "w-100": "",
      direction: "vertical"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_appStartupUser, {
          isCofounder: false,
          user: _ctx.business.founder
        }, null, 8, ["user"]),
        (_ctx.business.coFoundersSize > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_divider),
              _createElementVNode("div", null, [
                _createVNode(_component_el_space, { fill: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.business.coFounders, (cofo, index) => {
                      return (_openBlock(), _createBlock(_component_appStartupUser, {
                        key: `${index}-user`,
                        coFounder: cofo,
                        isCofounder: true
                      }, null, 8, ["coFounder"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}